var React = require('react');

function Nowash (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Ikoner/Do-not-wash","stroke":"#000","strokeWidth":"2","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"id":"Rectangle-17","d":"M2.31 5.06l4.104 33h30.79l4.105-33h0","key":0}),React.createElement("path",{"d":"M3.8 14.113c2.157 0 3.381-3.629 5.84-3.629 2.458 0 3.477 3.629 6.067 3.629 2.59 0 3.562-3.629 6.049-3.629 2.487 0 3.499 3.629 6.289 3.629 2.79 0 3.468-3.629 5.97-3.629 2.501 0 3.388 3.629 5.885 3.629","id":"Line-6","strokeLinecap":"square","key":1}),React.createElement("g",{"id":"x","transform":"translate(.857 1)","strokeLinecap":"square","key":2},[React.createElement("path",{"d":"M40.81 1.111L1.06 41.584","id":"Line-29","key":0}),React.createElement("path",{"d":"M1.06 1.111l39.75 40.473","id":"Line-29-Copy","key":1})])]));
}

Nowash.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = Nowash;

Nowash.default = Nowash;
